import { useCallback } from 'react';

import * as pas from '../../../pas';
import { useContinueLoginWithSessionToken } from '../../useContinueLoginWithSessionToken';

export const useContinueLogin = () => {
    const continueLoginWithSessionToken = useContinueLoginWithSessionToken();

    return useCallback(async ({ credentials, afterRegisterLogin, isAfterLoginWithCredentials }) => {
        const { data: { sessionToken: { sessionToken } } } = await pas.getTempToken();

        await continueLoginWithSessionToken({ ...credentials, sessionToken, afterRegisterLogin, isAfterLoginWithCredentials });
    }, [continueLoginWithSessionToken]);
};
